<div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
        <h1 class="govuk-heading-xl">{{this.selectedDepartment?.extra?.review_page_title}}</h1>
    </div>

    <div class="govuk-grid-column-full">
        <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
            data-module="govuk-notification-banner">
            <div class="govuk-notification-banner__header">
                <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                    Important
                </h2>
            </div>
            <div class="govuk-notification-banner__content">
                <p aria-label="Notification message"
                    class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse">
                    {{'COMMON.SUMMARY_NOTIFICATION' | translate}}
                </p>
            </div>
        </div>
    </div>

    <div class="govuk-grid-column-full">

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title" aria-label="Service">
                    {{'COMMON.SERVICE' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Service Name">
                            {{'COMMON.SERVICE_NAME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedService?.name}}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Duration">
                            {{'COMMON.DURATION' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedService?.calculated_duration}} minutes
                        </dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title" aria-label="Location">
                    {{'COMMON.LOCATION' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Site">
                            Venue
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedResourceObj?.name}}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title" aria-label="Date Time">
                    {{'COMMON.DATE_TIME' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Date">
                            {{'COMMON.DATE' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.start | date: 'EEEE d MMMM yyyy' : '' : translateService.currentLang}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Time">
                            {{'COMMON.TIME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.displayTime}}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title" aria-label="Booking details">
                    {{ 'COMMON.PATIENT_DETAILS' | translate }}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Name">
                            {{'COMMON.NAME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{client?.first_name}} {{client?.last_name}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key" aria-label="Email address">
                            {{'COMMON.EMAIL_ADDRESS' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{client?.email_address}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row" *ngIf="selectedSlot?.mobile_number">
                        <dt class="govuk-summary-list__key" aria-label="Mobile number">
                            {{'COMMON.MOBILE_NUMBER' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.mobile_number}}
                        </dd>
                    </div>

                    <div class="govuk-summary-list__row" *ngIf="client?.postcode">
                        <dt class="govuk-summary-list__key" aria-label="Postcode">
                            {{'COMMON.POSTNAME' | translate}}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{selectedSlot?.postcode}}
                        </dd>
                    </div>

                </dl>
            </div>
        </div>

        <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
                <h2 class="govuk-summary-card__title" aria-label="Booking details">
                    {{'COMMON.BOOKING_DETAILS' | translate}}
                </h2>
            </div>
            <div class="govuk-summary-card__content">
                <dl class="govuk-summary-list" *ngFor="let detail of bookingSummaryData">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{ detail.name | translateSplit }}
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ formatQuestion(detail.answer) }}
                        </dd>
                    </div>
                </dl>
                <!-- <dl class="govuk-summary-list" *ngFor="let detail of companySummaryData">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            {{ detail.name | translateSplit }}
                        </dt>
                        <dd class="govuk-summary-list__value">
                              {{ formatQuestion(detail.answer) }}
                        </dd>
                    </div>
                </dl> -->
            </div>
        </div>
        
        <app-cost-breakdown *ngIf="selectedDepartment && adminJourney" [company]="selectedDepartment"
        [costBreakDown]="costBreakDown" [currentPage]="pageName"></app-cost-breakdown>

        <br/>
        <app-cost-breakdown-vat *ngIf="selectedDepartment && communityVenue" [company]="selectedDepartment"
        [costBreakDown]="costBreakDown" [currentPage]="pageName"></app-cost-breakdown-vat>        

        <ng-container *ngIf="adminJourney">
            <div class="govuk-summary-card">
                <div class="govuk-summary-card__title-wrapper">
                    <h2 class="govuk-summary-card__title" aria-label="Booking details">
                        {{'COMMON.ADMIN_BOOKING_DETAILS' | translate}}
                    </h2>
                </div>
                <form [formGroup]="adminForm" class="govuk-summary-card__content">
                    <div class="govuk-form-group"
                        [ngClass]="{'govuk-form-group--error': form.amount.errors?.required == true && adminFormSubmitted}">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--s" for="amount">
                                <span aria-hidden="true" class="form-field-required-marker">
                                    *</span>Payment amount
                            </label>
                        </h1>
                        <p *ngIf="form.amount?.errors && adminFormSubmitted" id="event-name-error"
                            class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate:
                            {value:
                            'COMMON.ADMIN_AMOUNT' | translate } }}
                        </p>
                        <div class="govuk-input__wrapper">
                            <div class="govuk-input__prefix" aria-hidden="true">£</div>
                            <input class="govuk-input" id="amount" name="amount" type="text" formControlName="amount">
                        </div>
                    </div>
                    <div class="govuk-form-group"
                        [ngClass]="{'govuk-form-group--error': form.reference.errors?.required == true && adminFormSubmitted}">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--s" for="reference">
                                <span aria-hidden="true" class="form-field-required-marker">
                                    *</span>Transaction reference generated from Capita Paye360
                            </label>
                        </h1>
                        <p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
                            class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate:
                            {value:
                            'COMMON.ADMIN_REF' | translate } }}
                        </p>
                        <input class="govuk-input" id="reference" name="reference" type="text"
                            formControlName="reference">
                    </div>

                    <div class="govuk-form-group"
                        [ngClass]="{'govuk-form-group--error': form.amount.errors?.required == true && adminFormSubmitted}">
                        <h1 class="govuk-label-wrapper">
                            <label class="govuk-label govuk-label--s" for="amount">
                                <span aria-hidden="true" class="form-field-required-marker">
                                    *</span>Type of payment
                            </label>
                        </h1>
                        <p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
                            class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate:
                            {value:
                            'COMMON.ADMIN_NOTE' | translate } }}
                        </p>
                        <select class="govuk-select" formControlName="note">
                            <option></option>
                            <option value="Ceremony Fee Only in Full">Ceremony Fee Only in Full</option>
                            <option value="Ceremony Fee & Certificates in Full">Ceremony Fee & Certificates in Full
                            </option>
                            <option value="Ceremony Fee Deposit & Certificates in Full`">Ceremony Fee Deposit &
                                Certificates in Full</option>
                        </select>
                    </div>
                    <!-- 
                    <div class="govuk-form-group" [ngClass]="{'govuk-form-group--error': form.certificate_removal.errors?.required == true && adminFormSubmitted}">
                        <h1 class="govuk-label-wrapper">
                          <label class="govuk-label govuk-label--s" for="reference">
                            How many certificates should be removed?
                          </label>
                        </h1>
                        <p *ngIf="form.certificate_removal?.errors && adminFormSubmitted" id="event-name-error" class="govuk-error-message">
                            <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate: {value:
                            'COMMON.ADMIN_REF' | translate } }}
                        </p>
                        <select formControlName="certificate_removal" class="govuk-select">
                            <option value="0" selected>0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                    -->

                </form>
            </div>
        </ng-container>

        <div>
            <p class="govuk-body" *ngIf="adminJourney">
                Please confirm that you have advised the customer of their ceremony fees and have checked the payment
                information is correct.
            </p>

            <p class="govuk-body" *ngIf="!adminJourney">
                Please confirm that you understand if you click cancel in the payment screen or payment cannot be taken
                at
                the time of booking, your ceremony booking will not be confirmed.
            </p>

            <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                <div class="govuk-checkboxes__item">
                    <input [(ngModel)]="confirmContinue" class="govuk-checkboxes__input" id="mustConfirm"
                        name="mustConfirm" type="checkbox" value="mustConfirm">

                    <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
                        I confirm I have advised the customer and the payment information is correct
                    </label>

                    <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
                        * I confirm and understand the above
                    </label>
                </div>
            </div>
            <br>
        </div>

        <div class="govuk-button-group">
            <button type="submit" class="govuk-button govuk-button--secondary" data-module="govuk-button"
                (click)="routerGoBack()">{{'COMMON.BACK' | translate}}
            </button>
            <button type="submit" class="govuk-button" data-module="govuk-button" [disabled]="!confirmContinue"
                (click)="startCheckout()">{{'COMMON.NEXT'
                | translate}}
            </button>
        </div>
    </div>
</div>